// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareFlyOutStyles } from "@ces/Overrides/Components/ProductCompareFlyOut";
import Close from "@ces/XDL/Icons/Close";
import { color, xScreen } from "@ces/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 300,
    cssOverrides: {
        scrim: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            height: 275px;
                        `,
                        css`
                            height: 275px;
                        `,
                        css`
                            height: 260px;
                        `,
                        css`
                            height: 260px;
                        `,
                    ],
                    "min",
                )}
        `,
        drawerBody: css`
            padding: 0 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            height: 275px;
                        `,
                        css`
                            height: 275px;
                        `,
                        css`
                            height: 260px;
                        `,
                        css`
                            height: 260px;
                        `,
                    ],
                    "min",
                )}
        `,
        drawerTitle: css`
            background: ${getColor("common.accent")};
            color: ${getContrastColor("common.accent")};
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {};

productCompareFlyOutStyles.headerGridContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
        margin-bottom: 4px;
    `,
};

productCompareFlyOutStyles.productContainer = {
    css: css`
        display: flex;
        align-items: start;
        height: 100%;
    `,
};

productCompareFlyOutStyles.carouselProductStyles = {
    productGridContainerStyles: {
        container: {
            css: css`
                background: transparent;
            `,
        },
        qtyInfo: {
            css: css`
                margin-bottom: 0;
                ${TypographyStyle} {
                    width: max-content;
                }
            `,
        },
    },
    productPriceStyles: {
        quoteMessage: {
            text: {
                size: "18px",
                lineHeight: "22px",
            },
        },
    },
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    color: "common.accent",
    sizeVariant: "small",
    css: css`
        padding: 0;

        :hover {
            background: none;
        }
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    variant: "tertiary",
    css: css`
        margin: 5px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
};

productCompareFlyOutStyles.carousel = {
    titleText: {
        css: css`
            display: none;
        `,
    },
    carouselSlideInner: {
        css: css`
            padding: 0 10px;
            display: flex;
            flex-direction: column;

            ${xScreen("lt", "md")} {
                padding: 0 24px;
            }
        `,
    },
};

productCompareFlyOutStyles.headerTitleText = {
    variant: "h5",
    css: css`
        ${xScreen("lt", "lg")} {
            margin: 5px;
        }
    `,
};

productCompareFlyOutStyles.carouselContainer = {
    gap: 0,
};

productCompareFlyOutStyles.removeProductFromCompareIcon = {
    size: 12,
    src: Close,
    color: "common.ui7",
    css: css`
        &:hover,
        &:focus {
            color: ${color("common.ui8")};
        }
    `,
};

productCompareFlyOutStyles.xngCarousel = {
    container: {
        css: css`
            .swiper-horizontal > .xng-pagination-container {
                position: static;
                bottom: auto;
                left: auto;
                height: 20px;
                justify-content: center;
            }
        `,
    },
};
